module.exports = __webpack_public_path__ + "img/section-meter-electricity-meter-analog-sm.9d458ee7.svg";